export enum MessageType {
  ADDITION = 'addition',
  CREATION = 'creation',
  MESSAGE = 'message',
  REMOVAL = 'removal',
  RENAMING = 'renaming',
}
